import { render, staticRenderFns } from "./RecentPosts.vue?vue&type=template&id=2f25b330&scoped=true&"
import script from "./RecentPosts.vue?vue&type=script&lang=js&"
export * from "./RecentPosts.vue?vue&type=script&lang=js&"
import style0 from "./RecentPosts.vue?vue&type=style&index=0&id=2f25b330&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25b330",
  null
  
)

export default component.exports